import app from './app';
import post from './post';
import assets from './assets';
import page from './page';
import user from './user';
import prism from './prism';
import contest from './contest';

export default {
  app,
  post,
  assets,
  page,
  user,
  prism,
  contest
};
